<template>
  <div>
    <v-data-table
      :loading="loading"
      :items="items"
      :headers="headers"
      :pagination.sync="localPagination"
      :total-items="localPagination.totalItems"
      disable-initial-sort
      hide-actions
      @update:pagination="() => emitPagination()"
    >
      <template #items="{ item }">
        <td class="text-xs-right">{{ item.index }}</td>
        <td class="text-xs-center">{{ item.documentNumber || '-' }}</td>
        <td>{{ item.executiveName || '-' }}</td>
        <td>{{ item.province || '-' }}</td>
        <td>{{ item.district || '-' }}</td>
        <td>{{ item.status || '-' }}</td>
        <td>{{ item.datetime | DateFormat('DD/MM/YYYY HH:mm') }}</td>
        <td>
          <v-btn icon small outline color="primary" @click="$emit('view', item)">
            <v-icon small>visibility</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-layout v-if="totalPages" class="mt-3">
      <v-spacer />
      <v-pagination
        v-model="localPagination.page"
        :length="totalPages"
        :total-visible="9"
        class="ml-auto"
        @input="() => emitPagination()"
      />
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localPagination: {
        page: 1,
        totalItems: 0,
        rowsPerPage: 10,
        ...this.pagination
      },
      headers: [
        { value: 'index', text: this.$t('no.'), sortable: false, align: 'right' },
        {
          value: 'documentNumber',
          text: this.$t('asset_wise.document_no'),
          sortable: false,
          align: 'center'
        },
        { value: 'executiveName', text: this.$t('asset_wise.executive_name'), sortable: false },
        { value: 'province', text: this.$t('Province'), sortable: false },
        { value: 'district', text: this.$t('asset_wise.district'), sortable: false },
        { value: 'status', text: this.$t('Status'), sortable: false },
        { value: 'datetime', text: this.$t('date_time'), sortable: false },
        { sortable: false }
      ],
      hasInit: false
    }
  },
  computed: {
    totalPages() {
      const { totalItems, rowsPerPage } = this.localPagination
      return Math.ceil(totalItems / rowsPerPage)
    }
  },
  watch: {
    pagination(value) {
      this.localPagination = { ...this.localPagination, ...value }
    }
  },
  methods: {
    emitPagination() {
      if (!this.hasInit) {
        this.hasInit = true
        return
      }
      this.$emit('update:pagination', this.localPagination)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Management/ExecutiveRecord/DataTable.vue